import { ComponentProps } from 'react';

import { BusinessSubscriptionModel } from '@pukka/api';
import { Unarray } from '@pukka/common/types';
import { stringUtils } from '@pukka/common/utils';
import { Tab } from '@pukka/ui-components';
import capitalize from 'lodash/capitalize';

import { BillingPersistedState } from './Billing.state';

function createDiscountDescriptionFromCoupon(totalDiscountPercentage?: number, additionalMonth?: number, code?: string) {
  const description = ([] as string[])
    .concat(totalDiscountPercentage ? `+Discount ${totalDiscountPercentage}%` : [])
    .concat(additionalMonth ? `+additional ${stringUtils.pluralize(additionalMonth, 'month', 's')}` : []);

  if (description.length && code) {
    description.push(`(${code})`);
  }

  return description.join('\n');
}

function getRecurringDiscountDescription(interval: string, percentage?: number) {
  return percentage ? `Special discount ${percentage}%\n${interval} recurring promo` : '';
}

function getIntervalFromMonth(month?: number) {
  switch (month) {
    case 1:
      return 'monthly';
    case 12:
      return 'yearly';
    default:
      return '';
  }
}

function getTabsFromData(calculations: BusinessSubscriptionModel.BillingCalculation[]) {
  return calculations
    .filter((c) => c.is_recurring)
    .slice()
    .sort((a, b) => (a.month ?? 0) - (b.month ?? 0))
    .map((c) => {
      const packageName = getIntervalFromMonth(c.month);

      return {
        value: packageName,
        title: capitalize(packageName),
        subtitle: c.discount_percentage ? `Get ${c.discount_percentage}% discount\nof total bill` : '',
        disabled() {
          return c.month === 1 && BillingPersistedState.recurring?.interval === 'yearly';
        },
      } as Unarray<ComponentProps<typeof Tab.Billing>['data']>;
    })
    .concat({
      value: 'regular',
      title: 'Switch to Regular',
      subtitle: 'Call our Customer Service 1500970',
      disabled: true,
    });
}

function getStatusColor(status: string) {
  switch (status) {
    case 'pending':
      return 'yellow';
    case 'failed':
      return 'red';
    case 'paid':
    case 'success':
      return 'green';
    default:
      return 'neutral';
  }
}

export { createDiscountDescriptionFromCoupon, getRecurringDiscountDescription, getIntervalFromMonth, getTabsFromData, getStatusColor };
